import { supabase } from "index";

export function getDownloadUrl({ path }: { path: string }): string {
    const { data } = supabase.storage.from("statements").getPublicUrl(path);

    return data.publicUrl;
}
